import { del, get, post, put } from '@api/request';

export const fetchCodefiles = async (
  { litigationService },
  authenticationToken,
  { payload: { caseType, type, name } },
) => {
  const params = [
    caseType ? `caseType=${caseType}` : '',
    type ? `type=${type}` : '',
    name ? `name=${name}` : '',
  ]
    .filter(x => x)
    .join('&');

  const url = `${litigationService}/litigation/codefiles?${params}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCodefileSummary = async (
  { litigationService },
  authenticationToken,
  { payload: { caseType, type, name } },
) => {
  const params = [
    caseType ? `caseType=${caseType}` : '',
    type ? `type=${type}` : '',
    name ? `name=${name}` : '',
  ]
    .filter(x => x)
    .join('&');

  const url = `${litigationService}/litigation/codefilesummary?${params}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createCodefile = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const url = `${litigationService}/litigation/codefiles`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateCodefile = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const { caseType, codeFileType, codeFileName, codeName } = payload;
  const url = `${litigationService}/litigation/codefile/${caseType}/${codeFileType}/${codeFileName}/${codeName}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteCodefile = async (
  { litigationService },
  authenticationToken,
  { payload: { caseType, type, name, code } },
) => {
  const url = `${litigationService}/litigation/codefile/${caseType}/${type}/${name}/${code}`;
  const { body } = await del(authenticationToken, url);
  return body;
};
